import { buildInfo } from "../buildInfo";
import { LocaleSwitcher } from "./LocaleSwitcher";

export function Bottomline() {
  return (
    <div className="bottomline">
      <div className="bottomline-right">
        <LocaleSwitcher className="language-switcher" showCurrency={false} />
        <span
          className="build-info"
          title={`Deploy fingerprint — built ${buildInfo.builtAt} · commit ${buildInfo.commit}`}
        >
          v{buildInfo.version} · {buildInfo.commit}
        </span>
      </div>
    </div>
  );
}
